import { useState, useEffect } from 'react'

// Uses IP-based geolocation (cached in sessionStorage) with timezone fallback
export function useIsKenya(): boolean {
  const [isKenya, setIsKenya] = useState<boolean>(() => {
    // Immediate: check sessionStorage cache from useGeoLocation
    try {
      const cached = sessionStorage.getItem('belo_geo')
      if (cached) {
        const geo = JSON.parse(cached)
        return geo.countryCode === 'KE'
      }
    } catch {}
    // Fallback: timezone check (instant, no network)
    try {
      return (
        Intl.DateTimeFormat().resolvedOptions().timeZone === 'Africa/Nairobi'
      )
    } catch {
      return false
    }
  })

  useEffect(() => {
    // Once geo data loads (from useGeoLocation's fetch), update if needed
    const checkGeo = () => {
      try {
        const cached = sessionStorage.getItem('belo_geo')
        if (cached) {
          const geo = JSON.parse(cached)
          setIsKenya(geo.countryCode === 'KE')
        }
      } catch {}
    }

    // Check periodically for a few seconds in case geo loads after mount
    const t1 = setTimeout(checkGeo, 1000)
    const t2 = setTimeout(checkGeo, 3000)
    return () => {
      clearTimeout(t1)
      clearTimeout(t2)
    }
  }, [])

  return isKenya
}

export function getPhoneDisplay(isKenya: boolean): string {
  return isKenya ? '0701 660 306' : '+254 701 660 306'
}
